export default __webpack_public_path__ + "static/media/pic.e1bc265f.svg";